import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PuritydefineHome } from './pages/PuritydefineHome';
export function PuritydefineApp() {
  return <Routes data-id="element-1010">
      <Route path="/" element={<PuritydefineHome data-id="element-1012" />} data-id="element-1011" />
    </Routes>;
}